const GTM = process.env.REACT_APP_GTM_ID;
const GA4 = process.env.REACT_APP_GA4_ID;
const PIXEL = process.env.REACT_APP_META_PIXEL_ID;
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

const addScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

let loaded = false;

export const loadTags = () => {
  if (GA4) window[`ga-disable-${GA4}`] = false;
  if (loaded) {
    if (GA4 && window.gtag) window.gtag("event", "page_view");
    return;
  }
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  if (GTM) {
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    addScript(`https://www.googletagmanager.com/gtm.js?id=${GTM}`);
  }
  if (GA4) {
    window[`ga-disable-${GA4}`] = false;
    addScript(`https://www.googletagmanager.com/gtag/js?id=${GA4}`);
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4, sessionStorage.getItem("epl_ga_debug") ? { debug_mode: true } : {});
  }
  if (PIXEL && !window.fbq) {
    const f = (window.fbq = function fbq() { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); });
    f.queue = [];
    f.loaded = true;
    f.version = "2.0";
    addScript("https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("consent", "grant");
    window.fbq("init", PIXEL);
    window.fbq("track", "PageView");
  }
};

export const initAnalytics = (consented) => {
  const params = new URLSearchParams(window.location.search);
  const utm = Object.fromEntries(UTM_KEYS.filter((k) => params.get(k)).map((k) => [k, params.get(k)]));
  if (Object.keys(utm).length) sessionStorage.setItem("epl_utm", JSON.stringify(utm));
  if (params.get("ga_debug") === "1") sessionStorage.setItem("epl_ga_debug", "1");
  if (consented) loadTags();
};

export const disableGa = () => {
  if (GA4) window[`ga-disable-${GA4}`] = true;
};

export const getUtm = () => JSON.parse(sessionStorage.getItem("epl_utm") || "{}");

// Google events only (Meta events go through lib/tracking). Never includes player or medical data.
export const track = (event, params = {}) => {
  if (!loaded) return;
  window.dataLayer.push({ event, ...params });
  if (window.gtag && GA4) window.gtag("event", event, params);
};

// Sends an event, then runs `next` once GA has sent it (or after a short timeout).
export const trackThen = (event, params, next) => {
  let done = false;
  const go = () => {
    if (!done) {
      done = true;
      next();
    }
  };
  if (!loaded || !window.gtag || !GA4 || window[`ga-disable-${GA4}`]) return go();
  window.dataLayer.push({ event, ...params });
  window.gtag("event", event, { ...params, event_callback: go, event_timeout: 1500 });
  setTimeout(go, 1800);
};
